<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>反算管理</el-breadcrumb-item>
      <el-breadcrumb-item>反算明细</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search" ref='searchbox' @submit.native.prevent>
      <el-form-item label="搜索：">
        <el-input placeholder="请输入计量点名称" @keyup.enter.native="search" v-model="formInline.meterPointName" size="small"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="请输入计量点地址" @keyup.enter.native="search" v-model="formInline.meterPointAddress" size="small"></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker size="small" v-model="formInline.month" type="month" value-format="yyyy-MM" placeholder="选择月">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'" label="所属部门">
        <el-select v-model="formInline.departmentId" placeholder="请选择" size="small">
          <el-option v-for="item in treeDate" :key="item.id" :label="item.departmentName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <!-- 	<prems-button size="mini"  label="生成账单" perms="sys:menu:add" @click="createBill" />
				<prems-button size="mini"  label="生成数据" perms="sys:menu:add" @click="createData" />
				<prems-button size="mini"  label="生成计算账单" perms="sys:menu:add" @click="createComputData" /> -->
      </el-form-item>


      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" :loading="loadStatus" type="success" icon="el-icon-download" @click="exportdata">导出</el-button>
      </el-form-item>
    </el-form>
    <!-- 数据列表 -->
    <el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row
      v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" ref="tablelist" stripe>

      <el-table-column prop="meterPointName" label="计量点名称">
      </el-table-column>
      <el-table-column prop="meterPointAddress" label="计量点地址">
      </el-table-column>
      <el-table-column prop="contractNo" label="合同编号">
      </el-table-column>
      <el-table-column prop="isPay" label="是否预付费">
        <template slot-scope="scope">
          <span v-if="scope.row.isPay">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>

      <el-table-column prop="payDay" label="账期">
      </el-table-column>

      <el-table-column prop="oldCost" label="原扣费费用(元)">
      </el-table-column>

      <el-table-column prop="newCost" label="实际扣除费用(元)">
      </el-table-column>

      <el-table-column prop="costFee" label="反算差额(元)">
      </el-table-column>
      <el-table-column prop="inverseDate" label="反算时间">
      </el-table-column>

    </el-table>

    <Pagination v-bind:child-msg="formInline" @callFather="callFather" v-if="showPage"></Pagination>


  </div>
</template>

<script>
  import {
    findInverseDetails,
    exportInverseDetails
  } from '../../api/userMG.js'
  import {
    getDepartmentTerminalInfoLis
  } from '../../api/energyMG'
  import {
    timestampToTime
  } from '@/utils/util'
  import PremsButton from "@/views/permission/PreButtom";
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false,
        showPage: true,
        loadStatus: false,
        treeDate: [],
        currid: '',
        formInline: {
          meterPointName: '',
          meterPointAddress: '',
          contractNo: '',
          departmentId: "",
          month: '',
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        loadLoadin: false,
        user: {},
        loadLoadin: false,
        dateData: [],
        dataList: [],
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        }
      }
    },
    // 注册组件
    components: {
      Pagination,
      PremsButton
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
	    this.formInline.month = this.getLastMonth()


      this.getJzData();
    },
    methods: {


      exportdata() {
        this.loadStatus = true

        exportInverseDetails(this.formInline).then(res => {
          var blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          }); //type这里表示xlsx类型
          var downloadElement = document.createElement('a');
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = '反算明细.xls'; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.loadStatus = false
          this.$message.success('表格生成成功！正在下载')
        }).catch(err => {
          this.loadStatus = false
          this.$message({
            message: '下载失败！',
            type: 'error',
            showClose: true
          })
        })
      },
	  getLastMonth() {
	      var year,lastMonth;
	      var date = new Date();
	      var nowYear = date.getFullYear();   //当前年：四位数字
	      var nowMonth = date.getMonth();     //当前月：0-11
	      if (nowMonth == 0) {   //如果是0，则说明是1月份，上一个月就是去年的12月
	          year = nowYear - 1;
	          lastMonth = 12;
	      }else { //不是1月份，年份为当前年，月份本来是要减1的，但是由于`getMonth()`的月份本身就是少了1的，所以月份不用变。
	          year = nowYear;
	          lastMonth = nowMonth;
	      }

	      lastMonth = lastMonth < 10 ? ('0' + lastMonth) : lastMonth;   //月份格式化：月份小于10则追加个0

	      let lastYearMonth = year + '-' + lastMonth;

	      return lastYearMonth;
	  },

      search() {
        this.pageparm.currentPage = 1
        this.formInline.currentPage = 1
        this.showPage = false
        this.getData()
        this.$nextTick(() => {
          this.showPage = true
        })
      },
      //生成计算账单
      createComputData() {

        calMeterInfoPrice().then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功！')
            this.getData()
          }
        })
      },
      //获取集中器信息
      getJzData: function() {
        this.loading = true
        return new Promise((resolve, reject) => {
          getDepartmentTerminalInfoLis().then(res => {
            this.treeLoad = false
            if (res.status == 1) {
              let arr = []
              this.treeDate = res.data.menuDepList
              this.formInline.departmentId = res.data.menuDepList[0].id
              this.getData()
              resolve(res.data.terIds)
            } else {
              this.$message.error(res.msg)
            }
          })
        })

      },



      getData() {
        this.loading = true
        findInverseDetails(this.formInline).then(res => {
            this.loading = false
            if (res.status == 1) {
              this.dataList = res.data.data || []
              this.formInline.currentPage = this.formInline.currentPage
              this.formInline.pageSize = this.formInline.pageSize
              this.formInline.total = res.data.totalCount
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('获取数据失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },
      getDate(val) {
        this.formInline.startTime = timestampToTime(this.dateData[0]).substring(0, 10)
        this.formInline.endTime = timestampToTime(this.dateData[1]).substring(0, 10)
        this.getData()
      }
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/prepayment/fsDetaile.vue